import React from "react"
import styled from "styled-components"
import { Link, FormattedMessage } from "gatsby-plugin-react-intl"

import { media, mixins } from "../styles"

import BackSVG from "../images/icons/back--small.inline.svg"

const BacklinkEl = styled(Link)`
  ${mixins.copy4};
  align-items: center;
  color: ${({ theme }) => theme.spaceblue};
  display: inline-flex;
  margin-right: 10px;
  text-decoration: none;
  transition: color ${({ theme }) => theme.transitionTime};

  &:hover {
    color: ${({ theme }) => theme.sun};
  }

  @media ${media.md} {
    order: 1;
  }
`

const Backlink = ({ to, text }) => {
  return (
    <BacklinkEl to={to}>
      <BackSVG />
      {text || <FormattedMessage id="back" />}
    </BacklinkEl>
  )
}

export default Backlink
